var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../BlocksElement';
import '../skeleton/skeleton';
import styles from './segmented-control-item.styles';
import { SlotController } from '../../controllers/slot-controller';
/**
 * @slot default - The component content
 * @slot before - use this slot to show content before default slot/content
 * @slot after - use this slot to show content after default slot/content
 * @fires bl-segment-item-select - emitted when a segmented-item is clicked.
 * @csspart base - The component's base wrapper.
 * @csspart button - The component's `<button>`.
 * @csspart part-before - The component's before slot.
 * @csspart wrapper - The component's wrapper.
 * @csspart part-default - The component's default slot.
 * @csspart part-after - The component's after slot.
 * @csspart skeleton - The component's skeleton element.
 */
export class BlocksSegmentedControlItem extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         * Set Active property
         */
        this.isActive = false;
        this.slots = new SlotController(this, null, 'before', 'after');
    }
    static { this.styles = styles; }
    /**
     * The event dispatched here 'bl-segment-item-select' is used internally
     */
    handleSegmentSelected() {
        if (!this.isLoading && !this.isActive) {
            this.isActive = true;
            this.dispatch({ eventName: 'bl-segment-item-select', detailObj: {} });
        }
    }
    render() {
        const componentClassNames = this.componentClassNames('cat-c-segmented-control-item', {
            'cat-is-active': this.isActive,
            'cat-is-loading': this.isLoading,
            'cat-is-iconOnly': this.iconOnly,
            'cat-is-disabled': this.disabled,
            'cat-c-segmented-control-item--has-before': this.slots.hasSlotted('before'),
            'cat-c-segmented-control-item--has-after': this.slots.hasSlotted('after')
        });
        return html `
      <div part="base" class="${componentClassNames}">
        ${this.isLoading
            ? html `<div part="wrapper" class="cat-c-segmented-control-item__loader-wrapper">
              <cat-skeleton
                part="skeleton"
                exportparts=${this.getExportParts('skeleton')}
                width=${ifDefined(this.loaderWidth)}
                size="sm"
              ></cat-skeleton>
            </div>`
            : html ` <button
              part="button"
              class="cat-c-segmented-control-item__button"
              type="button"
              @click=${this.handleSegmentSelected}
              aria-pressed=${this.isActive}
              ?disabled=${this.disabled}
              tabindex="-1"
            >
              <div part="wrapper" class="cat-c-segmented-control-item__wrapper" tabindex=${this.disabled ? '-1' : '0'}>
                <slot part="part-before" name="before" class="cat-c-segmented-before-slot"></slot>
                <slot part="part-default"></slot>
                <slot part="part-after" name="after" class="cat-c-segmented-after-slot"></slot>
              </div>
            </button>`}
      </div>
    `;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], BlocksSegmentedControlItem.prototype, "isActive", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BlocksSegmentedControlItem.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BlocksSegmentedControlItem.prototype, "iconOnly", void 0);
__decorate([
    property({ type: Boolean })
], BlocksSegmentedControlItem.prototype, "isLoading", void 0);
__decorate([
    property({ type: String })
], BlocksSegmentedControlItem.prototype, "loaderWidth", void 0);
if (customElements.get('cat-segmented-control-item') === undefined) {
    customElements.define('cat-segmented-control-item', BlocksSegmentedControlItem);
}
